import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../api'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api:axios,
    papertitle:process.env.VUE_APP_PAPERTITLE,
    shareimg:process.env.VUE_APP_SHAREIMG,
    is_xhn:false
  },
  mutations: {
    set_xhn(state,data){
      state.is_xhn = data
      }
  },
  actions: {
  },
})
